export class BloodProduct {
    id = null;
    name = null;
    code = null;
    description = null;
}